<template>
  <div>
    <div class="page-title">Edit Entity</div>
    <Notice v-if="envAgnostic" type="info" title="Environment Agnostic">
      Changes here apply to both staging and production — no deployment needed.
    </Notice>
    <Form :submit="update" v-model="form" v-if="form" btnText="Update Entity" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.data-loader-entities.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}”` : `Edit Entity`,
    };
  },
  data() {
    return {
      form: {},
    };
  },
  created() {
    this.setForm();
  },
  beforeDestroy() {
    this.$store.commit("ui/setEnvAgnostic", false);
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.DataLoaderEntity.get({
        id: this.$route.params.id,
        schema_id: this.$route.params.schema_id,
      });
      this.form = data;
      if (data.schema?.environment_agnostic) {
        this.$store.commit("ui/setEnvAgnostic", true);
      }
    },
    async update() {
      await this.$api.DataLoaderEntity.update(this.form);
      this.$allertWindow("Successfully updated");
    },
  },
};
</script>

<style></style>
